import { NativeStackScreenProps } from '@react-navigation/native-stack';
import { NavigationStacks, Screens, Stacks } from 'components/Navigation/types';
import { useSelector } from 'hooks/useSelector';
import * as React from 'react';
import {
  selectAseIsOnline,
  selectAseControlInAssessment,
} from 'store/assessments/selectors';

import { useScreenSize } from 'hooks/useScreenSize';
import { useDispatch } from 'react-redux';
import {
  doAseOpenFieldInstance,
  doAseOpenQuestion,
  doAseOpenSection,
} from 'store/actions';
import { ScreenSize } from 'lib/constants';
import { ControlEdit } from './PagesMain/ControlEdit';
import { ControlDisplay } from './PagesMain/ControlDisplay';

type Props = NativeStackScreenProps<
  NavigationStacks[Stacks.ASSESSMENT],
  Screens.ASE_CONTROL
>;

export const ControlScreen: React.FC<Props> = ({ navigation, route }) => {
  const { id, parent, data } = route.params;
  const dispatch = useDispatch();
  const screenSize = useScreenSize();
  const isOnline = useSelector(selectAseIsOnline);
  const inAssessment = useSelector((state) =>
    selectAseControlInAssessment(state, id),
  );

  const shouldClose = !!id && !inAssessment && !data.isReview;
  React.useEffect(() => {
    if (shouldClose) {
      if (screenSize === ScreenSize.small) {
        navigation?.goBack();
      } else if (data.questionId) {
        dispatch(
          doAseOpenQuestion({
            id: data.questionId,
            fieldInstanceId: data.fieldInstanceId,
            parent,
          }),
        );
      } else if (data.fieldInstanceId) {
        dispatch(
          doAseOpenFieldInstance({
            instanceId: data.fieldInstanceId,
            parent,
            scrollTo: true,
          }),
        );
      } else if (data.sectionId) {
        dispatch(doAseOpenSection({ id: data.sectionId }));
      }
    }
  }, [shouldClose, navigation, parent, data, screenSize, dispatch]);

  if (!isOnline && inAssessment !== false) {
    return (
      <ControlEdit
        route={{ params: { id, parent, data } }}
        navigation={navigation}
      />
    );
  }
  return (
    <ControlDisplay
      route={{ params: { id, parent, data } }}
      navigation={navigation}
    />
  );
};

type PropsR = NativeStackScreenProps<
  NavigationStacks[Stacks.ASEREPEATABLE],
  Screens.ASEREPEATABLE_CONTROL
>;

export const ControlRepeatableScreen: React.FC<PropsR> = ({
  navigation,
  route,
}) => {
  const { id, parent, data } = route.params;
  const dispatch = useDispatch();
  const screenSize = useScreenSize();
  const isOnline = useSelector(selectAseIsOnline);
  const inAssessment = useSelector((state) =>
    selectAseControlInAssessment(state, id),
  );

  const shouldClose = !!id && !inAssessment && !data.isReview;
  React.useEffect(() => {
    if (shouldClose) {
      if (screenSize === ScreenSize.small) {
        navigation?.goBack();
      } else if (data.questionId) {
        dispatch(
          doAseOpenQuestion({
            id: data.questionId,
            fieldInstanceId: data.fieldInstanceId,
            parent,
          }),
        );
      } else if (data.fieldInstanceId) {
        dispatch(
          doAseOpenFieldInstance({
            instanceId: data.fieldInstanceId,
            parent,
            scrollTo: true,
          }),
        );
      } else if (data.sectionId) {
        dispatch(doAseOpenSection({ id: data.sectionId }));
      }
    }
  }, [shouldClose, navigation, parent, data, screenSize, dispatch]);

  if (!isOnline && inAssessment !== false) {
    return (
      <ControlEdit
        route={{ params: { id, parent, data } }}
        navigation={navigation}
      />
    );
  }
  return (
    <ControlDisplay
      route={{ params: { id, parent, data } }}
      navigation={navigation}
    />
  );
};
